import { ModalConfirm } from '@finbeat/react-toolkit';
import { useTranslation } from 'react-i18next';

const OrderUnsavedChangesConfirm = ({
    isOpen,
    closeNotify,
    closeWindow,
}: {
    isOpen: boolean;
    closeNotify: () => void;
    closeWindow: () => void;
}) => {
    const { t } = useTranslation();
    return (
        <ModalConfirm
            isOpen={isOpen}
            content={t('BackOfficeUnsavedChanges')}
            confirmButtonContent={t('BackOfficeOk')}
            cancelButtonContent={t('BackOfficeCancel')}
            toggle={(res) => {
                if (res) closeWindow();
                closeNotify();
            }}
        />
    );
};

export default OrderUnsavedChangesConfirm;
